import { TooltipButton } from '@/components/molecules/tooltip-button';
import { PRIVILEGES } from '@/hooks/access/access-table';
import { useActionPermission } from '@/hooks/use-action-permission';
import { Stack } from '@/ux-common/components/stack/stack';

export const AddStageButton = ({ onClick }: { onClick: () => void }) => {
  const { isDisabled: disabledByPermissions, tooltipText } = useActionPermission({
    privilege: PRIVILEGES.writeCommands,
  });

  return (
    <TooltipButton
      disabled={disabledByPermissions}
      onClick={onClick}
      className="btn btn-xs"
      showTooltipWhenEnabled
      tooltipContent={
        <Stack className="stack-thin">
          <span className="font-bold">{'Add Stage'}</span>
          <span>{disabledByPermissions ? tooltipText : undefined}</span>
        </Stack>
      }
    >
      {'Add Stage'}
    </TooltipButton>
  );
};
